"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselKeyboardInstructions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PhotoCarouselKeyboardInstructions = require("./PhotoCarouselKeyboardInstructions.styles");
/**
 * A badge that appears when a Property Card Photo Carousel gets focus.
 * It informs users that they can navigate the carousel using their keyboards.
 *
 * @since 8.66.0
 */
var PhotoCarouselKeyboardInstructions = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PhotoCarouselKeyboardInstructions.StyledPhotoCarouselKeyboardInstructions, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PhotoCarouselKeyboardInstructions = PhotoCarouselKeyboardInstructions;
PhotoCarouselKeyboardInstructions.displayName = 'PropertyCard.KeyboardInstructions';